module.exports = __webpack_public_path__ + "static/media/circleBasedh.cac2cf75.svg";